import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { showFilterlist, SWAL_SETTINGS } from "../../../../utils/Constants";
import {
    formateDateWithMonth,
    handleServerValidations,
} from "../../../../utils/commonfunction";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import StatusFilter from "../../common/statusFilter";
import CustomPagination from "../../common/custompagination";
import { List, Status, Delete } from "../../services/pujaCategory.services";

const PujaCategoryTable = () => {
    const { t } = useTranslation();
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [statsupdate, setStatusUpdate] = useState(false);
    const [datalength, setDataLength] = useState("");
    const [itemperpage] = useState(10);
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true);
    const [search, setSearch] = useState({});
    const [globalsearch, setGlobalSearch] = useState("");
    const [resetdate, setResetDate] = useState(false);

    const breadcrumbs = [
        { title: t("link_dashboard"), url: "/admin/dashboard" },
        { title: "Categories", url: "" },
    ];

    useEffect(() => {
        const getData = setTimeout(() => {
            setLoader(true);
            const formData = new FormData();
            formData.append("page", params.pgno || 1);
            formData.append("per_page", itemperpage);
            formData.append("sort", JSON.stringify(sorting));
            formData.append("search", JSON.stringify(search));
            formData.append("global_search", globalsearch);

            List(formData)
                .then((data) => {
                    setDataLength(data.data.total_records);
                    setList(data && data.data && data.data.list ? data.data.list : []);
                    setPage(data && data.data && data.data.page ? data.data.page : 1);
                    setLoader(false);
                })
                .catch((error) => {
                    console.log("error ====> ", error);
                    setLoader(false);
                });
        }, 300);
        return () => clearTimeout(getData);
    }, [location, statsupdate, sorting, search, globalsearch, itemperpage, params.pgno]);

    const ChangeStatus = (id, Num) => {
        const payload = { id: id, status: Num };
        Swal.fire({
            customClass: "swal-wide",
            title: t(
                `Are you sure you want to ${Num === 0 ? "deactivate" : "activate"} this puja category?`
            ),
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: t("btn_cancel"),
            confirmButtonColor: "#403fad",
            cancelButtonColor: "#f1388b",
            confirmButtonText: t("btn_yes"),
        }).then((result) => {
            if (result.isConfirmed) {
                Status(payload)
                    .then((response) => {
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            setStatusUpdate(!statsupdate);
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("error===>", error);
                    });
            }
        });
    };

    function Deletefunction(id) {
        Swal.fire({
            customClass: "swal-wide",
            title: t("msg_are_you_sure"),
            text: t("you_not_be_able_to_revert_this"),
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: t("btn_cancel"),
            confirmButtonColor: "#403fad",
            cancelButtonColor: "#f1388b",
            confirmButtonText: t("btn_yes_delete"),
        }).then((result) => {
            if (result.isConfirmed) {
                Delete({ id: id })
                    .then((response) => {
                        setStatusUpdate(!statsupdate);
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("deleteError", error);
                    });
            }
        });
    }

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    };

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    };

    const resetFilter = (e) => {
        e.preventDefault();
        setGlobalSearch("");
        setSearch({});
        setResetDate(!resetdate);
    };

    const getImageUrl = (imagePath) => {
        if (!imagePath) return null;
        if (imagePath.startsWith("http")) return imagePath;
        return `${process.env.REACT_APP_API_URL || ""}/${imagePath}`;
    };

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="animation_fade">
                <div className="card custom-card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h6 className="main-content-label">Categories</h6>
                            <div className="d-flex align-items-center">
                                <div className="form-group mb-0 me-3">
                                    <div className="form-group mb-0 rangepicker_container filter_design">
                                        <i className="fa fa-search calender_icon"></i>
                                        <input
                                            type="search"
                                            className="form-control"
                                            value={globalsearch}
                                            placeholder={t("input_placeholder_search")}
                                            onChange={(e) => setGlobalSearch(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="me-3">
                                    <StatusFilter
                                        data={showFilterlist}
                                        prepareSearch={prepareSearch}
                                    />
                                </div>
                                <button
                                    type="reset"
                                    onClick={resetFilter}
                                    className="btn btn-warning float-right mr-2"
                                >
                                    {t("btn_reset_filter")}
                                </button>
                                <button
                                    className="btn ripple btn-main-primary signbtn mr-2"
                                    onClick={() => navigate(`/admin/puja-category/add`)}
                                >
                                    {t("btn_add_new")}
                                </button>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                                <thead>
                                    <tr>
                                        <th className="position-relative select_head">
                                            <span>{t("list_heading_sno")}</span>
                                        </th>
                                        <th>Image</th>
                                        <th>
                                            <div className="sorting_column">
                                                <span>Title</span>
                                                <Sorting
                                                    sort={sorting}
                                                    handleSort={handleSort}
                                                    column="title"
                                                />
                                            </div>
                                        </th>
                                        <th>Type</th>
                                        <th>Chart Type</th>
                                        <th>
                                            <div className="sorting_column">
                                                <span>Sort Order</span>
                                                <Sorting
                                                    sort={sorting}
                                                    handleSort={handleSort}
                                                    column="sort_order"
                                                />
                                            </div>
                                        </th>
                                        <th>Description</th>
                                        <th className="created_head">
                                            <div className="sorting_column">
                                                <span>{t("list_heading_created_date")}</span>
                                                <Sorting
                                                    sort={sorting}
                                                    handleSort={handleSort}
                                                    defaultSorting={defaultSorting}
                                                    column="created_at"
                                                />
                                            </div>
                                        </th>
                                        <th className="status_head">{t("list_heading_status")}</th>
                                        <th className="action_head">{t("list_heading_action")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader && datalength > 0 ? (
                                        <tr>
                                            <td colSpan={10}>
                                                <Loader />
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            {list.length ? (
                                                list.map((row, i) => (
                                                    <tr key={i}>
                                                        <td>
                                                            {row
                                                                ? (page - 1) * itemperpage + i + 1
                                                                : null}
                                                        </td>
                                                        <td>
                                                            {row?.image ? (
                                                                <img
                                                                    src={getImageUrl(row.image)}
                                                                    alt={row.title}
                                                                    style={{
                                                                        width: "50px",
                                                                        height: "50px",
                                                                        objectFit: "cover",
                                                                        borderRadius: "8px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <span className="text-muted">N/A</span>
                                                            )}
                                                        </td>
                                                        <td>{row?.title || "N/A"}</td>
                                                        <td>
                                                            <span className={`badge bg-${row?.type === 'expertise' ? 'info' : 'primary'} text-capitalize`}>
                                                                {row?.type || "puja"}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            {row?.type === 'expertise' ? (
                                                                <span className="badge bg-secondary text-capitalize">
                                                                    {row?.chart_type || "single"}
                                                                </span>
                                                            ) : (
                                                                <span className="text-muted">-</span>
                                                            )}
                                                        </td>
                                                        <td>{row?.sort_order || 0}</td>
                                                        <td>
                                                            <span
                                                                title={row?.description}
                                                                style={{
                                                                    display: "inline-block",
                                                                    maxWidth: "200px",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                }}
                                                            >
                                                                {row?.description || "N/A"}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            {(row.created_at || row.createdAt)
                                                                ? formateDateWithMonth(row.created_at || row.createdAt)
                                                                : "N/A"}
                                                        </td>
                                                        <td>
                                                            {Number(row.status) === 1 ? (
                                                                <button
                                                                    className="btn ripple btn-main-primary signbtn"
                                                                    onClick={() => ChangeStatus(row?.id, 0)}
                                                                >
                                                                    {t("btn_active")}
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    className="btn ripple btn-secondary"
                                                                    onClick={() => ChangeStatus(row?.id, 1)}
                                                                >
                                                                    {t("btn_inactive")}
                                                                </button>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <button
                                                                    className="btn ripple btn-success mlAction"
                                                                    onClick={() =>
                                                                        navigate(
                                                                            `/admin/puja-category/edit/${row.id}`
                                                                        )
                                                                    }
                                                                >
                                                                    {t("btn_edit")}
                                                                </button>
                                                                <button
                                                                    className="btn ripple btn-secondary mlAction"
                                                                    onClick={() => Deletefunction(row?.id)}
                                                                >
                                                                    {t("btn_delete")}
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={10} className="text-center">
                                                        {t("msg_no_records")}
                                                    </td>
                                                </tr>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="mt-3">
                            <b>
                                {t("msg_total_records")} : {datalength ? datalength : "0"}
                            </b>
                        </div>
                        {datalength && datalength > 0 ? (
                            <CustomPagination
                                datalength={datalength}
                                itemperpage={itemperpage}
                                currentPage={page}
                                setPage={setPage}
                                pageRoute={[
                                    {
                                        name: "Puja Category",
                                        path: "/admin/puja-category/list",
                                    },
                                ]}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PujaCategoryTable;
